import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5d52734e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5d52734e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d52734e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d52734e')) {
      api.createRecord('5d52734e', component.options)
    } else {
      api.reload('5d52734e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5d52734e&scoped=true", function () {
      api.rerender('5d52734e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/spellGroup/goodsList/index.vue"
export default component.exports